<template>
  <router-link :to="to" class="link py-2" exact-active-class="link-selected">
    <i class="material-icons link-icon px-4">{{icon}}</i>
    <span class="link-title font-weight-lightweight">
      <slot></slot>
    </span>
  </router-link>
</template>

<script>
export default {
  name: "sidebarlink",
  props: {
    icon: String,
    selected: Boolean,
    to: String
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.link {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  color: white;
  user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  cursor: pointer;
  &-selected {
    background: {
      color: #444;
    }
  }
}
.link:hover {
  background: {
    color: #222;
  }
  text-decoration: none;
}

.link:active {
  background: {
    color: #444;
  }
}
</style>
